import { render, staticRenderFns } from "./ShortArticleContainer.vue?vue&type=template&id=74471e7c&"
import script from "./ShortArticleContainer.vue?vue&type=script&lang=js&"
export * from "./ShortArticleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports